import { resolveAppMode } from './appMode';

interface LoginURLRedirectOptions {
  pathname?: string;
  search?: string;
}

/**
 * Gets the appropriate login URL based on app type (wpsitecontrol.com or not)
 * for the new design
 *
 * @param options - redirects the user to the correct page when passed
 */
export const getLoginURL = (options?: LoginURLRedirectOptions) => {
  const { pathname, search } = options || {};

  const { isWpSiteControl, loginUrl } = resolveAppMode();

  if (isWpSiteControl) {
    return loginUrl;
  }

  if (typeof pathname !== 'undefined' && typeof search !== 'undefined') {
    return `/login?retUrl=${pathname}${search}`;
  }

  return '/login';
};
